import { classnames } from '@app/utils/index.js';
import type { PropsWithChildren } from 'react';
import { useMemo } from 'react';

interface IProps {
  title: string;
  step: number;
  maxStep: number;
}

export default function CheckoutFormStep(props: PropsWithChildren<IProps>) {
  const isCurrent = useMemo(() => true, []);
  const isLast = useMemo(() => props.maxStep === props.step, [props.maxStep, props.step]);

  return (
    <div className="flex justify-center gap-x-12">
      <div className="max-w-[10rem] w-full relative hidden tablet:flex flex-col">
        <div className="flex items-center gap-x-2 z-10">
          <span
            className={classnames(
              'w-8 h-8 flex shrink-0 items-center justify-center rounded-full',
              {
                'bg-primary': isCurrent,
                'text-white': isCurrent,
                'bg-gray-300': !isCurrent,
              }
            )}>
            {props.step}
          </span>
          <span
            className={classnames('font-semibold', {
              'text-primary': isCurrent,
              'text-gray-500': !isCurrent,
            })}>
            {props.title}
          </span>
        </div>
        <div
          className={classnames('absolute top-0 left-4 w-[2px] bg-primary-light -translate-x-1/2', {
            'h-full': props.maxStep > props.step,
            'h-4': isLast,
          })}
        />
      </div>
      <div className={classnames('flex-auto', { 'pb-8': !isLast })}>{props.children}</div>
    </div>
  );
}
